import {RestrictionFilter} from '@app/core/model/filtering/restriction-filter';
import {AttributeEntityItem, OneAttributeEntity} from '@app/core/model/integration-models';
import {PredicateModel} from '@app/core/model/filtering/predicate-model';

export class FilteringChangeEvent {
    type: string;
    action: string;
    object: any;

    static isEqual(a: FilteringChangeEvent, b: FilteringChangeEvent): boolean {
        return a && b && a.type === b.type && a.action === b.action
            && (!!a.object === !!b.object) && (!b.object
                || (
                    (!!a.object.filter === !!b.object.filter)
                    && (!a.object.filter || RestrictionFilter.isEqual(a.object.filter, b.object.filter))
                    && (!!a.object.entity === !!b.object.entity)
                    && (!a.object.entity || OneAttributeEntity.isEqual(a.object.entity, b.object.entity))
                    && (!!a.object.attr === !!b.object.attr)
                    && (!a.object.attr || AttributeEntityItem.isEqual(a.object.attr, b.object.attr))
                    && (!!a.object.predicate === !!b.object.predicate)
                    && (!a.object.predicate || PredicateModel.isEqual(a.object.predicate, b.object.predicate))
                    && (!!a.object.oldEntity === !!b.object.oldEntity)
                    && (!a.object.oldEntity || OneAttributeEntity.isEqual(a.object.oldEntity, b.object.oldEntity))
                    && (!!a.object.oldAttr === !!b.object.oldAttr)
                    && (!a.object.oldAttr || AttributeEntityItem.isEqual(a.object.oldAttr, b.object.oldAttr))
                    && (a.object.oldIsCompleted === b.object.oldIsCompleted)
                )
        );
    }

    equals(event: FilteringChangeEvent): boolean {
        return FilteringChangeEvent.isEqual(this, event);
    }
}

export enum FiltersChangeTypes {
    RULE_CHANGED = 'rule-changed',
    FILTER_CHANGED = 'filter-changed',
    FILTER_ATTR_CHANGED = 'filter-attr-changed',
    FILTER_PREDICATE_CHANGED = 'filter-predicate-changed',
    FILTER_VALUE_CHANGED = 'filter-value-changed'
}
